export default __webpack_public_path__ + "static/media/light_arrow.d2546223.svg";